import {
  PAYOFF_PARTICIPATION_BASE_BONUS_AMOUNT,
  PAYOFF_PARTICIPATION_BASE_BONUS_STRIKE,
  PAYOFF_PARTICIPATION_BASE_CAPPED,
  PAYOFF_PARTICIPATION_BASE_DIRECTION,
  PAYOFF_PARTICIPATION_BASE_GLOBAL_CAP,
  PAYOFF_PARTICIPATION_BASE_GLOBAL_FLOOR,
  PAYOFF_PARTICIPATION_BASE_INITIAL_LEVEL_AS_DENOMINATION,
  PAYOFF_PARTICIPATION_BASE_ISSUE_AT_DISCOUNT,
  PAYOFF_PARTICIPATION_BASE_BARRIER_LEVEL,
  PAYOFF_PARTICIPATION_BASE_KNOCK_OUT_BONUS,
  PAYOFF_PARTICIPATION_BASE_LEVERAGE,
  PAYOFF_PARTICIPATION_BASE_OBS_FREQUENCY,
  PAYOFF_PARTICIPATION_BASE_STRIKE,
  PAYOFF_PARTICIPATION_BASE_TOUCH_AND_BREAK,
  PAYOFF_PARTICIPATION_BASE_TYPE,
  PAYOFF_PARTICIPATION_BASE_UPPER_PARTICIPATION,
  PAYOFF_PARTICIPATION_BASE_BARRIER_TYPE,
  PAYOFF_PARTICIPATION_BASE_BARRIER_INVESTMENT_ALLOCATION,
  PAYOFF_PARTICIPATION_BASE_BARRIER_LEVELS_AND_INVESTMENTS,
  PAYOFF_PARTICIPATION_BASE_BARRIER_INVESTMENT_LEVEL,
  PAYOFF_PARTICIPATION_BASE_INITIAL_CASH_ALLOCATION,
  PAYOFF_PARTICIPATION_BASE_INITIAL_INVESTMENT_ALLOCATION,
} from './product-capture-field-selectors.consts';

import { BaseTypeEnum } from 'src/app/product-capture/model/consts/participation-base-type.const';
import { FCFieldEffect, FCSelector } from '../../model/form-config.interface';

const CLEAR_BARRIER_EFFECT: FCFieldEffect = {
  formControlNames: [PAYOFF_PARTICIPATION_BASE_BARRIER_LEVEL],
  selectValues: [null],
};

const CLEAR_GLOBAL_FLOOR_EFFECT: FCFieldEffect = {
  formControlNames: [PAYOFF_PARTICIPATION_BASE_GLOBAL_FLOOR],
  selectValues: [null],
};

const CLEAR_BASE_STRIKE_EFFECT: FCFieldEffect = {
  formControlNames: [PAYOFF_PARTICIPATION_BASE_STRIKE],
  selectValues: [null],
};

const CLEAR_BONUS_STRIKE_EFFECT: FCFieldEffect = {
  formControlNames: [PAYOFF_PARTICIPATION_BASE_BONUS_STRIKE],
  selectValues: [null],
};

const CLEAR_BONUS_AMOUNT_EFFECT: FCFieldEffect = {
  formControlNames: [PAYOFF_PARTICIPATION_BASE_BONUS_AMOUNT],
  selectValues: [null],
};

const CLEAR_UPPER_PARTICIPATION_EFFECT: FCFieldEffect = {
  formControlNames: [PAYOFF_PARTICIPATION_BASE_UPPER_PARTICIPATION],
  selectValues: [null],
};

export const BASE_TYPE: FCSelector = {
  formControlNames: [PAYOFF_PARTICIPATION_BASE_TYPE],
  options: [
    {
      id: 'NONE',
      effects: [
        {
          formControlNames: [
            PAYOFF_PARTICIPATION_BASE_LEVERAGE,
            PAYOFF_PARTICIPATION_BASE_BONUS_STRIKE,
            PAYOFF_PARTICIPATION_BASE_BONUS_AMOUNT,
            PAYOFF_PARTICIPATION_BASE_GLOBAL_CAP,
            PAYOFF_PARTICIPATION_BASE_GLOBAL_FLOOR,
            PAYOFF_PARTICIPATION_BASE_BARRIER_LEVEL,
            PAYOFF_PARTICIPATION_BASE_OBS_FREQUENCY,
            PAYOFF_PARTICIPATION_BASE_TOUCH_AND_BREAK,
            PAYOFF_PARTICIPATION_BASE_KNOCK_OUT_BONUS,
            PAYOFF_PARTICIPATION_BASE_STRIKE,
            PAYOFF_PARTICIPATION_BASE_UPPER_PARTICIPATION,
            PAYOFF_PARTICIPATION_BASE_CAPPED,
            PAYOFF_PARTICIPATION_BASE_ISSUE_AT_DISCOUNT,
            PAYOFF_PARTICIPATION_BASE_INITIAL_LEVEL_AS_DENOMINATION,
            PAYOFF_PARTICIPATION_BASE_INITIAL_CASH_ALLOCATION,
            PAYOFF_PARTICIPATION_BASE_INITIAL_INVESTMENT_ALLOCATION,
            PAYOFF_PARTICIPATION_BASE_BARRIER_INVESTMENT_ALLOCATION,
            PAYOFF_PARTICIPATION_BASE_BARRIER_LEVELS_AND_INVESTMENTS,
            PAYOFF_PARTICIPATION_BASE_BARRIER_INVESTMENT_LEVEL,
          ],
          hidden: true,
        },
        { ...CLEAR_BARRIER_EFFECT },
      ],
    },
    {
      id: BaseTypeEnum.DELTA_N,
      effects: [
        {
          formControlNames: [
            PAYOFF_PARTICIPATION_BASE_BONUS_STRIKE,
            PAYOFF_PARTICIPATION_BASE_BONUS_AMOUNT,
            PAYOFF_PARTICIPATION_BASE_BARRIER_LEVEL,
            PAYOFF_PARTICIPATION_BASE_OBS_FREQUENCY,
            PAYOFF_PARTICIPATION_BASE_TOUCH_AND_BREAK,
            PAYOFF_PARTICIPATION_BASE_KNOCK_OUT_BONUS,
            PAYOFF_PARTICIPATION_BASE_STRIKE,
            PAYOFF_PARTICIPATION_BASE_UPPER_PARTICIPATION,
            PAYOFF_PARTICIPATION_BASE_CAPPED,
            PAYOFF_PARTICIPATION_BASE_INITIAL_CASH_ALLOCATION,
            PAYOFF_PARTICIPATION_BASE_INITIAL_INVESTMENT_ALLOCATION,
            PAYOFF_PARTICIPATION_BASE_BARRIER_INVESTMENT_ALLOCATION,
            PAYOFF_PARTICIPATION_BASE_BARRIER_LEVELS_AND_INVESTMENTS,
            PAYOFF_PARTICIPATION_BASE_BARRIER_INVESTMENT_LEVEL,
          ],
          hidden: true,
        },
        {
          formControlNames: [
            PAYOFF_PARTICIPATION_BASE_LEVERAGE,
            PAYOFF_PARTICIPATION_BASE_GLOBAL_CAP,
            PAYOFF_PARTICIPATION_BASE_GLOBAL_FLOOR,
          ],
          hidden: false,
        },
        { ...CLEAR_BARRIER_EFFECT },
        { ...CLEAR_BASE_STRIKE_EFFECT },
        { ...CLEAR_BONUS_STRIKE_EFFECT },
        { ...CLEAR_BONUS_AMOUNT_EFFECT },
        { ...CLEAR_UPPER_PARTICIPATION_EFFECT },
      ],
    },
    {
      id: BaseTypeEnum.BONUS_CERTIFICATE,
      effects: [
        {
          formControlNames: [
            PAYOFF_PARTICIPATION_BASE_BARRIER_LEVEL,
            PAYOFF_PARTICIPATION_BASE_OBS_FREQUENCY,
            PAYOFF_PARTICIPATION_BASE_TOUCH_AND_BREAK,
            PAYOFF_PARTICIPATION_BASE_KNOCK_OUT_BONUS,
            PAYOFF_PARTICIPATION_BASE_LEVERAGE,
            PAYOFF_PARTICIPATION_BASE_GLOBAL_FLOOR,
            PAYOFF_PARTICIPATION_BASE_INITIAL_CASH_ALLOCATION,
            PAYOFF_PARTICIPATION_BASE_INITIAL_INVESTMENT_ALLOCATION,
            PAYOFF_PARTICIPATION_BASE_BARRIER_INVESTMENT_ALLOCATION,
            PAYOFF_PARTICIPATION_BASE_BARRIER_LEVELS_AND_INVESTMENTS,
            PAYOFF_PARTICIPATION_BASE_BARRIER_INVESTMENT_LEVEL,
          ],
          hidden: true,
        },
        {
          formControlNames: [
            PAYOFF_PARTICIPATION_BASE_BONUS_STRIKE,
            PAYOFF_PARTICIPATION_BASE_BONUS_AMOUNT,
            PAYOFF_PARTICIPATION_BASE_CAPPED,
            PAYOFF_PARTICIPATION_BASE_BARRIER_LEVEL,
            PAYOFF_PARTICIPATION_BASE_OBS_FREQUENCY,
            PAYOFF_PARTICIPATION_BASE_TOUCH_AND_BREAK,
            PAYOFF_PARTICIPATION_BASE_STRIKE,
            PAYOFF_PARTICIPATION_BASE_UPPER_PARTICIPATION,
            PAYOFF_PARTICIPATION_BASE_LEVERAGE,
          ],
          hidden: false,
        },
        {
          formControlNames: [PAYOFF_PARTICIPATION_BASE_BONUS_AMOUNT],
          readOnly: true,
        },
        { ...CLEAR_GLOBAL_FLOOR_EFFECT },
      ],
    },
    {
      id: BaseTypeEnum.BONUS_CERTIFICATE_NO_BARRIER,
      effects: [
        {
          formControlNames: [
            PAYOFF_PARTICIPATION_BASE_LEVERAGE,
            PAYOFF_PARTICIPATION_BASE_GLOBAL_FLOOR,
            PAYOFF_PARTICIPATION_BASE_BARRIER_LEVEL,
            PAYOFF_PARTICIPATION_BASE_OBS_FREQUENCY,
            PAYOFF_PARTICIPATION_BASE_TOUCH_AND_BREAK,
            PAYOFF_PARTICIPATION_BASE_KNOCK_OUT_BONUS,
            PAYOFF_PARTICIPATION_BASE_INITIAL_CASH_ALLOCATION,
            PAYOFF_PARTICIPATION_BASE_INITIAL_INVESTMENT_ALLOCATION,
            PAYOFF_PARTICIPATION_BASE_BARRIER_INVESTMENT_ALLOCATION,
            PAYOFF_PARTICIPATION_BASE_BARRIER_LEVELS_AND_INVESTMENTS,
            PAYOFF_PARTICIPATION_BASE_BARRIER_INVESTMENT_LEVEL,
          ],
          hidden: true,
        },
        {
          formControlNames: [
            PAYOFF_PARTICIPATION_BASE_BONUS_AMOUNT,
            PAYOFF_PARTICIPATION_BASE_BONUS_STRIKE,
            PAYOFF_PARTICIPATION_BASE_STRIKE,
            PAYOFF_PARTICIPATION_BASE_CAPPED,
            PAYOFF_PARTICIPATION_BASE_UPPER_PARTICIPATION,
            PAYOFF_PARTICIPATION_BASE_LEVERAGE,
          ],
          hidden: false,
        },
        {
          formControlNames: [PAYOFF_PARTICIPATION_BASE_BONUS_AMOUNT],
          readOnly: true,
        },
        { ...CLEAR_BARRIER_EFFECT },
        { ...CLEAR_GLOBAL_FLOOR_EFFECT },
      ],
    },
    {
      id: BaseTypeEnum.DISCOUNT_CERTIFICATE,
      effects: [
        {
          formControlNames: [
            PAYOFF_PARTICIPATION_BASE_TOUCH_AND_BREAK,
            PAYOFF_PARTICIPATION_BASE_OBS_FREQUENCY,
            PAYOFF_PARTICIPATION_BASE_BARRIER_LEVEL,
            PAYOFF_PARTICIPATION_BASE_BONUS_AMOUNT,
            PAYOFF_PARTICIPATION_BASE_BONUS_STRIKE,
            PAYOFF_PARTICIPATION_BASE_GLOBAL_FLOOR,
            PAYOFF_PARTICIPATION_BASE_UPPER_PARTICIPATION,
            PAYOFF_PARTICIPATION_BASE_LEVERAGE,
            PAYOFF_PARTICIPATION_BASE_INITIAL_CASH_ALLOCATION,
            PAYOFF_PARTICIPATION_BASE_INITIAL_INVESTMENT_ALLOCATION,
            PAYOFF_PARTICIPATION_BASE_BARRIER_INVESTMENT_ALLOCATION,
            PAYOFF_PARTICIPATION_BASE_BARRIER_LEVELS_AND_INVESTMENTS,
            PAYOFF_PARTICIPATION_BASE_BARRIER_INVESTMENT_LEVEL,
          ],
          hidden: true,
        },
      ],
    },
    {
      id: BaseTypeEnum.BARRIER_DISCOUNT_CERTIFICATE,
      effects: [
        {
          formControlNames: [
            PAYOFF_PARTICIPATION_BASE_INITIAL_CASH_ALLOCATION,
            PAYOFF_PARTICIPATION_BASE_INITIAL_INVESTMENT_ALLOCATION,
            PAYOFF_PARTICIPATION_BASE_BARRIER_INVESTMENT_ALLOCATION,
            PAYOFF_PARTICIPATION_BASE_BARRIER_LEVELS_AND_INVESTMENTS,
            PAYOFF_PARTICIPATION_BASE_BARRIER_INVESTMENT_LEVEL,
          ],
          hidden: true,
        },
        {
          formControlNames: [
            PAYOFF_PARTICIPATION_BASE_TOUCH_AND_BREAK,
            PAYOFF_PARTICIPATION_BASE_OBS_FREQUENCY,
            PAYOFF_PARTICIPATION_BASE_BARRIER_LEVEL,
          ],
          hidden: false,
        },
        {
          formControlNames: [PAYOFF_PARTICIPATION_BASE_TOUCH_AND_BREAK],
          selectValues: [false],
        },
        {
          formControlNames: [PAYOFF_PARTICIPATION_BASE_BARRIER_LEVEL],
          selectValues: [null],
        },
        {
          formControlNames: [PAYOFF_PARTICIPATION_BASE_OBS_FREQUENCY],
          selectValues: ['PERIOD_END'],
        },
        {
          formControlNames: [PAYOFF_PARTICIPATION_BASE_DIRECTION],
          selectValues: ['DOWN_AND_IN'],
          hidden: true,
        },
      ],
    },
    {
      id: BaseTypeEnum.DROPBACK_CERTIFICATE,
      effects: [
        {
          formControlNames: [
            PAYOFF_PARTICIPATION_BASE_LEVERAGE,
            PAYOFF_PARTICIPATION_BASE_BONUS_STRIKE,
            PAYOFF_PARTICIPATION_BASE_BONUS_AMOUNT,
            PAYOFF_PARTICIPATION_BASE_GLOBAL_CAP,
            PAYOFF_PARTICIPATION_BASE_GLOBAL_FLOOR,
            PAYOFF_PARTICIPATION_BASE_BARRIER_LEVEL,
            PAYOFF_PARTICIPATION_BASE_OBS_FREQUENCY,
            PAYOFF_PARTICIPATION_BASE_TOUCH_AND_BREAK,
            PAYOFF_PARTICIPATION_BASE_KNOCK_OUT_BONUS,
            PAYOFF_PARTICIPATION_BASE_STRIKE,
            PAYOFF_PARTICIPATION_BASE_UPPER_PARTICIPATION,
            PAYOFF_PARTICIPATION_BASE_CAPPED,
            PAYOFF_PARTICIPATION_BASE_ISSUE_AT_DISCOUNT,
            PAYOFF_PARTICIPATION_BASE_INITIAL_LEVEL_AS_DENOMINATION,
          ],
          hidden: true,
        },
        {
          formControlNames: [PAYOFF_PARTICIPATION_BASE_BARRIER_LEVEL],
          selectValues: [null],
        },
        {
          formControlNames: [PAYOFF_PARTICIPATION_BASE_BARRIER_TYPE],
          selectValues: ['LADDER'],
          readOnly: true,
          hidden: true,
        },
        {
          formControlNames: [PAYOFF_PARTICIPATION_BASE_OBS_FREQUENCY],
          selectValues: ['DAILY_CONTINUOUS'],
          readOnly: false,
          hidden: false,
        },
        {
          formControlNames: [
            PAYOFF_PARTICIPATION_BASE_BARRIER_INVESTMENT_LEVEL,
          ],
          selectValues: ['AT_BARRIER_LEVEL'],
          hidden: false,
          readOnly: false,
        },
        {
          formControlNames: [PAYOFF_PARTICIPATION_BASE_DIRECTION],
          selectValues: ['DOWN_AND_IN'],
          hidden: true,
          readOnly: true,
        },
        {
          formControlNames: [PAYOFF_PARTICIPATION_BASE_TOUCH_AND_BREAK],
          selectValues: [true],
          readOnly: false,
          hidden: false,
        },
        {
          formControlNames: [
            PAYOFF_PARTICIPATION_BASE_INITIAL_CASH_ALLOCATION,
            PAYOFF_PARTICIPATION_BASE_INITIAL_INVESTMENT_ALLOCATION,
            PAYOFF_PARTICIPATION_BASE_BARRIER_LEVELS_AND_INVESTMENTS,
            PAYOFF_PARTICIPATION_BASE_BARRIER_INVESTMENT_LEVEL,
          ],
          hidden: false,
          readOnly: false,
        },
      ],
    },
    {
      id: '',
      effects: [
        {
          formControlNames: [
            PAYOFF_PARTICIPATION_BASE_LEVERAGE,
            PAYOFF_PARTICIPATION_BASE_BONUS_STRIKE,
            PAYOFF_PARTICIPATION_BASE_BONUS_AMOUNT,
            PAYOFF_PARTICIPATION_BASE_GLOBAL_CAP,
            PAYOFF_PARTICIPATION_BASE_GLOBAL_FLOOR,
            PAYOFF_PARTICIPATION_BASE_BARRIER_LEVEL,
            PAYOFF_PARTICIPATION_BASE_OBS_FREQUENCY,
            PAYOFF_PARTICIPATION_BASE_TOUCH_AND_BREAK,
            PAYOFF_PARTICIPATION_BASE_KNOCK_OUT_BONUS,
            PAYOFF_PARTICIPATION_BASE_STRIKE,
            PAYOFF_PARTICIPATION_BASE_UPPER_PARTICIPATION,
            PAYOFF_PARTICIPATION_BASE_CAPPED,
          ],
          hidden: false,
        },
        { ...CLEAR_BARRIER_EFFECT },
      ],
    },
  ],
};
